module.exports = __webpack_public_path__ + "static/media/社区团购_07.00ac3567.jpg";